const composeEventHandlers = function (theirsHandler, oursHandler) {
  let _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$checkForDefaultP = _ref.checkForDefaultPrevented,
    checkForDefaultPrevented = _ref$checkForDefaultP === void 0 ? true : _ref$checkForDefaultP;
  const handleEvent = event => {
    const shouldPrevent = theirsHandler == null ? void 0 : theirsHandler(event);
    if (checkForDefaultPrevented === false || !shouldPrevent) {
      return oursHandler == null ? void 0 : oursHandler(event);
    }
  };
  return handleEvent;
};
const whenMouse = handler => {
  return e => e.pointerType === "mouse" ? handler(e) : void 0;
};
export { composeEventHandlers, whenMouse };